<template>
  <v-container fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="grey lighten-4" primary-title>
        <h2>Registrar</h2>
      </v-card-title>
      <v-card-text v-if="loading">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
      <v-card-text v-if="!loading">
        <v-form v-model="valid">
          <v-text-field
           v-model="username"
           :rules="usernameRules"
           label="Digite seu usuário ou email"
           prepend-icon="email"
           required
          ></v-text-field>
          <v-text-field
            @click:append="showP = !showP"
            v-model="senha"
            :rules="senhaRules"
            label="Senha"
            prepend-icon="lock"
            required
            :type="showP ? 'text' : 'password'"
            :append-icon="showP ? 'visibility_off' : 'visibility'"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn small color="primary" @click="onLoginClick()">Login</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onRegistrarClick()" :disabled="!valid">Registrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import store from '../store'
import fornecedorService from '../services/fornecedor'
import { showError, showFlash } from '../utils'
import auth from '@/services/auth'

export default {
  name: 'Registrar',
  props: {
    source: String
  },
  data () {
    return {
      step: 1,
      store,
      loading: false,
      username: '',
      senha: '',
      valid: true,
      valid1: true,
      showP: false,
      fornecedor: {},
      timerCount: 0,
      usernameRules: [v => !!v || 'Campo obrigatório'],
      nomeRules: [v => !!v || 'Campo obrigatório'],
      senhaRules: [v => !!v || 'Campo obrigatório']
    }
  },
  mounted () {
    // showError('O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. O usuário foi salvo com sucesso. ')
    // showFlash('Bem vindo!')
  },
  methods: {
    onLoginClick () {
      this.$router.push(`/login`)
    },
    async onRegistrarClick () {
      try {
        this.fornecedor['usuario'] = this.username.toLowerCase()
        this.fornecedor['senha'] = this.senha
        await fornecedorService.saveRegistro(this.fornecedor)
        showFlash('Dados gravados com sucesso')
      } catch (error) {
        showError(error)
      }
    },
    onLogoutClick () {
      auth.logout()
    }
  }
}
</script>
